export default __webpack_public_path__ + "static/media/tesla_logo_small.a7b59bc6.svg";